import SmoothScroll from 'smooth-scroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/**
 * Global Footer functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalFooter {
  /**
   * Constructs a new GlobalFooter instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.scrollUpBtn = this.element.querySelector('[data-component="scroll-up"]')
    this.shapesBg = this.element.querySelector('[data-component="shapes-bg"]')
    this.imageEl = this.shapesBg.querySelector('picture')
    this.tagLine = this.element.querySelector('.tagline')
    this.linksColumns = this.element.querySelectorAll('.links > ul > li')
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 1000,
      updateURL: false,
      speedAsDuration: true
    }
    this.scrollUpBtn.addEventListener('click', () => {
      this.scroll.animateScroll(0, this.logo, this.scrollOptions)
    })

    const globalFooterTL = gsap.timeline({ paused: true })
    globalFooterTL.to(this.shapesBg, { duration: 1, autoAlpha: 1, ease: 'power2' })
    globalFooterTL.to(this.imageEl, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')
    globalFooterTL.to(this.tagLine, { duration: 1, autoAlpha: 1, ease: 'power2' })
    globalFooterTL.to(this.linksColumns, { duration: 0.5, autoAlpha: 1, stagger: 0.15 }, '<')

    ScrollTrigger.create({
      trigger: this.element,
      start: 'top 60%',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        globalFooterTL.play()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/global-footer/index.js